import skillHtml from "../assets/img/html.png";
import skillCss from "../assets/img/css.png";
import skillJs from "../assets/img/js.png";
import skillReact from "../assets/img/react.png";
import skillFigma from "../assets/img/figma.png";
import skillWordpress from "../assets/img/wordpress.png";
import skillVite from "../assets/img/vite-logo.png";
import skillBootstrap from "../assets/img/Bootstrap_logo.png";
import skillTailwind from "../assets/img/Tailwind_CSS_Logo.png";
import skillC from "../assets/img/C_Logo.png";
import skillFramer from "../assets/img/white-mark.png";
import skillGsap from "../assets/img/gsaplogo.png";
import skillCanva from "../assets/img/canva-icon.png";
import skillGithubWhite from "../assets/img/github.png";
import skillDebuggingWhite from "../assets/img/debugging-white.svg";
import skillVercelWhite from "../assets/img/vercel-white.svg";
import skillAdobeXdWhite from "../assets/img/adobe-xd-white.svg";
import skillPhotoshopWhite from "../assets/img/photoshop-white.svg";
import skillIllustratorWhite from "../assets/img/illustrator-white.svg";

import projCampusBites from "../assets/img/campusbites.png";
import projAgroPlus from "../assets/img/agroplus.png";
import projNewsApp from "../assets/img/newsapp.png";
import projEximo from "../assets/img/eximo.png";
import projAgroPlusUi from "../assets/img/agroplusapp.png";
import projLoginFlow from "../assets/img/loginsignup.png";
import projCampusBitesUi from "../assets/img/campusbitesui.png";
import projFoodApp from "../assets/img/foodapp.png";
import projAntiDrone from "../assets/img/antidrone.png";
import projAmazonClone from "../assets/img/amazonclone.png";
import projNetflixClone from "../assets/img/netflixclone.png";
import projAppleIphone from "../assets/img/appleiphone.png";
import projPunchPilot from "../assets/img/punchpilot.png";
import projSpotifyClone from "../assets/img/spotifyclone.png";

import companyBharatIntern from "../assets/img/bharatintern.png";
import companyCodeInfosys from "../assets/img/codeinfosys.png";
import companyNanditech from "../assets/img/NTS-Logo.png";

import hackCvmu from "../assets/img/cvmuhackathon.png";
import hackSih from "../assets/img/sihhackathon.jpg";
import hackPolice from "../assets/img/hackathon.jpg";
import hackCodeUnnati from "../assets/img/codeunnatimarathon.png";

import eduCsulb from "../assets/img/csulb.png";
import eduAdit from "../assets/img/adit.jpeg";

export const skills = [
  { name: "HTML5", image: skillHtml },
  { name: "CSS", image: skillCss },
  { name: "JavaScript", image: skillJs },
  {
    name: "TypeScript",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
  },
  { name: "React", image: skillReact },
  {
    name: "Angular",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg",
  },
  {
    name: "Next.js",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
  },
  { name: "Figma", image: skillFigma },
  { name: "WordPress", image: skillWordpress },
  { name: "Vite", image: skillVite },
  { name: "Bootstrap", image: skillBootstrap },
  { name: "TailwindCSS", image: skillTailwind },
  {
    name: "Node.js",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
  },
  {
    name: "Express",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
  },
  {
    name: "MongoDB",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
  },
  {
    name: "MySQL",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
  },
  {
    name: "Firebase",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg",
  },
  {
    name: "Git",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
  },
  {
    name: "GitHub",
    image: skillGithubWhite,
  },
  {
    name: "Vercel",
    image: skillVercelWhite,
  },
  {
    name: "Netlify",
    image: "https://www.vectorlogo.zone/logos/netlify/netlify-icon.svg",
  },
  { name: "C", image: skillC },
  {
    name: "C++",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg",
  },
  {
    name: "Python",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
  },
  {
    name: "Adobe XD",
    image: skillAdobeXdWhite,
  },
  {
    name: "Photoshop",
    image: skillPhotoshopWhite,
  },
  {
    name: "Illustrator",
    image: skillIllustratorWhite,
  },
  { name: "Framer", image: skillFramer },
  { name: "GSAP", image: skillGsap },
  { name: "Canva", image: skillCanva },
  {
    name: "UI/UX",
    image: "https://cdn-icons-png.flaticon.com/512/1055/1055687.png",
  },
  {
    name: "Data Structures",
    image: "https://cdn-icons-png.flaticon.com/512/2721/2721297.png",
  },
  {
    name: "Debugging",
    image: skillDebuggingWhite,
  },
];

export const frontendProjects = [
  {
    title: "CampusBites",
    description: "Design & Frontend Development",
    imgUrl: projCampusBites,
    projectLink: "https://github.com/sahajmaniya/campusbites",
    linkType: "github",
  },
  {
    title: "AgroPlus",
    description: "Frontend Development",
    imgUrl: projAgroPlus,
    projectLink: "https://github.com/sahajmaniya/agroplus",
    linkType: "github",
  },
  {
    title: "Apple iPhone",
    description: "Frontend Development",
    imgUrl: projAppleIphone,
    projectLink: "https://apple-iphone-gules.vercel.app/",
    linkType: "live",
  },
  {
    title: "PunchPilot",
    description: "Frontend Development",
    imgUrl: projPunchPilot,
    projectLink: "https://punchpilot.online/",
    linkType: "live",
  },
  {
    title: "NewsApp",
    description: "Design & Development",
    imgUrl: projNewsApp,
    projectLink: "https://github.com/sahajmaniya/NewsApp",
    linkType: "github",
  },
  {
    title: "Anti Drone System",
    description: "Frontend Development",
    imgUrl: projAntiDrone,
    projectLink: "https://github.com/sahajmaniya/Anti-Drone-System",
    linkType: "github",
  },
  {
    title: "Amazon Clone",
    description: "Frontend Development",
    imgUrl: projAmazonClone,
    projectLink: "https://amazon-clone-sable-rho.vercel.app/",
    linkType: "live",
  },
  {
    title: "Netflix Clone",
    description: "Frontend Development",
    imgUrl: projNetflixClone,
    projectLink: "https://nteflix-clone.vercel.app/",
    linkType: "live",
  },
  {
    title: "Spotify Clone",
    description: "Frontend Development",
    imgUrl: projSpotifyClone,
    projectLink: "https://spotify-clone-one-tau-73.vercel.app/",
    linkType: "live",
  },
];

export const uiProjects = [
  {
    title: "Eximo International",
    description: "UI Design",
    imgUrl: projEximo,
    projectLink:
      "https://www.figma.com/community/file/1390614877034497584/import-export-websites-ui",
  },
  {
    title: "AgroPlus",
    description: "UI Design",
    imgUrl: projAgroPlusUi,
    projectLink: "https://www.figma.com/community/file/1352958247793191913/agroplus",
  },
  {
    title: "Login-Signup Flow",
    description: "UI Design",
    imgUrl: projLoginFlow,
    projectLink:
      "https://www.figma.com/community/file/1352216708452689255/login-signup-page-flow",
  },
  {
    title: "CampusBites",
    description: "UI Design",
    imgUrl: projCampusBitesUi,
    projectLink:
      "https://www.figma.com/design/u9GtqOjCP02khTeTLf0kow/CampusBite?node-id=0-1&t=Dd7QrOXO3Tv6yZ6f-1",
  },
  {
    title: "FoodApp",
    description: "UI Design",
    imgUrl: projFoodApp,
    projectLink: "https://www.figma.com/community/file/1376936179291410711/food-menu-app",
  },
];

export const experiences = [
  {
    companyImage: companyBharatIntern,
    role: "Web Developer Intern",
    companyName: "Bharat Intern",
    jobDuration: "Aug 2023 - Sep 2023",
  },
  {
    companyImage: companyCodeInfosys,
    role: "Frontend Developer Intern",
    companyName: "Code Infosys",
    jobDuration: "May 2024 - June 2024",
  },
  {
    companyImage: companyNanditech,
    role: "Frontend Developer",
    companyName: "Nanditech Solutions",
    jobDuration: "Jan 2025 - June 2025",
  },
];

export const hackathons = [
  {
    id: 1,
    imgSrc: hackCvmu,
    title: "CVMU Hackathon 1.0",
    location: "ADIT, Anand",
    chipLabel: "Details",
    time: "Mar 2023",
    hackathonlink: "https://www.cvmu.edu.in/cvmuhackathon",
  },
  {
    id: 2,
    imgSrc: hackPolice,
    title: "Police Hackathon",
    location: "Vadodara, Gujarat",
    chipLabel: "Details",
    time: "Aug 2023",
    hackathonlink: "https://www.instagram.com/pierc_pu/p/Cvi9rjtSBEl",
  },
  {
    id: 3,
    imgSrc: hackSih,
    title: "SIH Hackathon",
    location: "Bangalore, India",
    chipLabel: "Details",
    time: "Dec 2023",
    hackathonlink: "https://www.sih.gov.in/sih2023",
  },
  {
    id: 4,
    imgSrc: hackCvmu,
    title: "CVMU Hackathon 2.0",
    location: "ADIT, Anand",
    chipLabel: "Details",
    time: "Mar 2024",
    hackathonlink: "https://www.cvmu.edu.in/cvmuhackathon",
  },
  {
    id: 5,
    imgSrc: hackCodeUnnati,
    title: "Code Unnati Marathon",
    location: "GTU, Ahmedabad",
    chipLabel: "Details",
    time: "Mar 2024",
    hackathonlink: "https://cu-innovation.edunetfoundation.com/",
  },
];

export const education = [
  {
    school: "California State University, Long Beach",
    degree: "Master of Science (MS), Computer Science",
    location: "Long Beach, CA, USA",
    period: "Aug 2025 - Aug 2027",
    logo: eduCsulb,
    link: "https://www.csulb.edu/",
    highlights: ["Graduate study in Computer Science."],
  },
  {
    school: "A D Patel Institute of Technology, CVM University",
    degree: "Bachelor of Engineering (BE), Information Technology",
    location: "Anand, Gujarat, India",
    period: "Oct 2021 - May 2025",
    logo: eduAdit,
    link: "https://www.adit.ac.in/",
    highlights: ["Grade: 8.23 / 10"],
  },
];
